import { useStore } from 'vuex'
import { ref } from 'vue'
import debounce from 'foundation/js/debounce'
import { post } from 'foundation/js/api'

export default {
    name: 'SearchAndCTACancerforum',
    props: {
        guid: {
            type: String,
            required: false,
            default: ''
        },
        groupId: {
            type: String,
            required: true
        },
        isLoggedIn: {
            type: Boolean,
            required: true
        },
        isClosedGroup: {
            type: Boolean,
            required: true
        },
        isUserAwaitingAccess: {
            type: Boolean,
            required: true
        },
        loginUrl: {
            type: String,
            required: false,
            default: ''
        }
    },
    setup(props) {
        const store = useStore()
        const inputText = ref('')
        const isSubmitting = ref(false)

        const termInput = debounce(() => {
            store.dispatch('search/performSearch', {
                guid: props.guid,
                query: inputText.value
            })
        }, 500)

        const createFundraise = function (e) {
            const currentUrl = location.href
            localStorage.setItem('flowheader__returnurl', currentUrl)
            location.href = e.target.href
        }

        const handleClick = async function (e) {
            if (!props.isLoggedIn) {
                window.location.href = props.loginUrl
                return
            }

            if (props.isClosedGroup) {
                store.dispatch('main/openPageOverlay', {
                    overlayContent: 'ClosedGroupOverlay',
                    returnTarget: e.currentTarget
                })
                return
            }

            isSubmitting.value = true

            const url = `${document.location.origin}/${process.env.FORUM_JOIN_GROUP}`.replace('[groupId]', props.groupId)
            await post(url, null)

            isSubmitting.value = false
            window.location.reload()
        }

        return {
            inputText,
            termInput,
            createFundraise,
            handleClick,
            isSubmitting
        }
    }
}
